import { Component, OnInit } from '@angular/core';
import { HttpClient  } from '@angular/common/http';
import { announcement_condition } from '../class/status';
import { announcement_urltype } from '../class/status';
import { menulist } from '../class/status';
import { page } from '../class/status';

@Component({
  selector: 'app-gametopic',
  templateUrl: './gametopic.component.html',
  styleUrls: ['./gametopic.component.css']
})
export class GametopicComponent implements OnInit {
  is_enablearr = ['下架','上架'];
  is_typearr = ['大冒險','真心話','大冒險','大冒險'];
  tcontent = [
      {title:'問題',content:'question'},
      {title:'提示',content:'hint'},
      {title:'加成係數',content:'ratio'},
      {title:'狀態',content:'is_enable',replaceArr:this.is_enablearr},
      {title:'修改時間',content:'update_dt'},
      {title:'操作',content:'gg',type:3},
  ];
  
  pageobj:page = {page:0,count:10,total_count:0};
  now:string='0';
  menu_list:menulist = [{id:'0',name:'你畫我猜'},{id:'1',name:'冒險轉盤'}]
  show_condition_list:menulist = [{id:'1',name:'日期區間'},{id:'2',name:'觀看次數'},{id:'3',name:'點閱次數'}]
  edit_data:any=[];
  data:any=[];
  loading:boolean=false;
  tmp_img_b64:{};
  announcement_condition = announcement_condition;
  announcement_urltype = announcement_urltype;
  pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj))
  constructor(public httpClient: HttpClient,) { }
  enumKeys=[];
  ngOnInit(): void {
    this.init_list();
  }

  save(type:number){
    this.update(0);
  } 

  add(){
    this.update(1);
  }

  update(type:number){
    this.loading = true;
    const body = {data:this.edit_data,type:type,gamemode:this.now};
    this.httpClient.post<any>("/update_gametopic_list.php",body).subscribe(res => {
      this.loading = false;
      console.log(res);
      this.init_list();
    });
  }

  init_list(){
    this.loading = true; 
    const body = {page: this.pageobj.page,count:this.pageobj.count,type:this.now};
    this.httpClient.post<any>("/get_gametopic_list.php",body).subscribe(res => {
      this.loading = false;
      if(res.status){
        this.data = res.data;
        this.pageobj.total_count = res.total_count
      }else{
        this.pageobj.total_count = 0
        this.data = [];
      }
      this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
    });
  }

  choose(value:string){
    this.now = value;

    switch (this.now) {
        case '0':
            this.tcontent = [
                {title:'問題',content:'question'},
                {title:'提示',content:'hint'},
                {title:'加成係數',content:'ratio'},
                {title:'狀態',content:'is_enable',replaceArr:this.is_enablearr},
                {title:'修改時間',content:'update_dt'},
                {title:'操作',content:'gg',type:3},
            ];
            break;
        case '1':
            this.tcontent = [
                {title:'類型',content:'type',replaceArr:this.is_typearr},
                {title:'問題',content:'description'},
                {title:'等級',content:'lv'},
                {title:'加成係數',content:'ratio'},
                {title:'狀態',content:'is_enable',replaceArr:this.is_enablearr},
                {title:'修改時間',content:'update_dt'},
                {title:'操作',content:'gg1',type:3},
            ];

            break;
        default:
            break;
    }



    this.pageobj.page = 0;
    this.init_list();
  }

  callback(pageobj:page){
    if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
      this.pageobj = pageobj;
      this.init_list();
    }
  }
}
